// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dockbar{box-shadow:1px -1px 8px rgba(0,0,0,.5);padding:10px 0}", ""]);
// Exports
module.exports = exports;
